import React from 'react';
import { Pane, Strong } from 'evergreen-ui';

/**
 * @param {string} label название для элемента children
 * @param {JSX.element} children элемент, который нужно назвать
 * @param {boolean} [row=false] позволяет название и children поставить в одну строку.
 */
export default function FormField({ className, label, children, row = false, ...propsPane }) {
  const style = row
    ? ({
      display: 'grid',
      alignItems: 'center',
      gridTemplateColumns: 'max-content 1fr',
      gridGap: '8px',
    })
    : ({
      display: 'grid',
      gridTemplateRows: 'max-content 1fr',
      gridGap: '4px',
    });
  return (
    <Pane className={className} style={style} {...propsPane}>
      <Strong fontWeight={500}>{label}</Strong>
      {children}
    </Pane>
  );
}
